module.exports = __webpack_public_path__ + "img/polar@2x.b6b5e3b.webp";